/** Clear stale body/html scroll locks left by modals (mobile web can get stuck). */
export function releasePageScrollLock() {
  if (typeof document === 'undefined') return

  const html = document.documentElement
  const body = document.body
  const top = body.style.top

  html.classList.remove('listing-detail-scroll-lock')
  body.style.overflow = ''
  body.style.position = ''
  body.style.top = ''
  body.style.width = ''

  if (top) {
    const y = Math.abs(parseInt(top, 10))
    if (Number.isFinite(y) && y > 0) {
      window.scrollTo(0, y)
    }
  }
}
